module.exports = __webpack_public_path__ + "img/015-flowchart.396f7ff9.svg";